import {
  IconProps,
  Text,
  HStack,
  Pressable,
} from "@whoosh/design-system/src/components/primitive";

type TabBarOverflowItemProps = {
  label: string;
  icon: (props: IconProps) => React.JSX.Element;
  onPress: () => void;
  selected: boolean;
};

export const TabBarOverflowItem = ({
  label,
  icon,
  onPress,
  selected,
}: TabBarOverflowItemProps) => {
  return (
    <Pressable
      p={4}
      width="100%"
      onPress={onPress}
      _hover={{
        backgroundColor: "grayscale-100",
      }}
      _focus={{
        backgroundColor: "surface-primary",
      }}
      backgroundColor={selected ? "grayscale-100" : "surface-primary"}
      borderRadius="2"
      accessibilityRole="menuitem"
    >
      <HStack gap={4} alignItems="center">
        {icon({ color: "grayscale-1000", fill: "none" })}
        <Text
          maxFontSizeMultiplier={2}
          variant="mainBaseMedium"
          color="grayscale-1000"
        >
          {label}
        </Text>
      </HStack>
    </Pressable>
  );
};
